import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { Immobilie } from '@ps20-frontend/frontend-models';

export const immobilienReducer = function (
  sectionState: Array<Immobilie> = null,
  action: AnyAction,
): Array<Immobilie> {
  switch (action.type) {
    case GlobalActions.AMIS_IMMOBILIEN_TRANSFORMED: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
